import { FunctionComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { useTheme } from '../../../hooks/use-theme/use-theme';
import { useCallback, useMemo } from 'preact/hooks';

interface Props {
	icon: IconDefinition;
	text: string;
	isActive: boolean;
	mapType: google.maps.MapTypeId;
	onClick: (mapType: google.maps.MapTypeId) => void;
}

const DEFAULT_COLOR = '#6D6D6D';

const MapSetting: FunctionComponent<Props> = ({ text, icon, isActive, mapType, onClick }) => {
	const { primaryColor } = useTheme();
	const handleClick = useCallback(() => onClick(mapType), [mapType, onClick]);
	const color = useMemo(() => (isActive ? primaryColor : DEFAULT_COLOR), [isActive, primaryColor]);

	return (
		<div className="setting" data-testid={`setting-${mapType}`} onClick={handleClick}>
			<FontAwesomeIcon icon={icon} className="setting-icon" style={{ color }} />
			<span className="setting-text" style={{ color }}>
				{text}
			</span>
		</div>
	);
};

export default MapSetting;
